<div class="row">
  <mat-form-field [style.width.%]="100" legacyAppearance>
    <mat-label i18n [attr.data-testid]="'stacker-name-label'"
      >疊加器名稱</mat-label
      >
      <input
        matInput
        [(ngModel)]="node.stackerName"
        [attr.data-testid]="'stacker-name-input'"
        />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field [style.width.%]="100" legacyAppearance>
      <mat-label i18n [attr.data-testid]="'card-merge-limit-label'"
        >卡片疊加數量</mat-label
        >
        <mat-select
          [(ngModel)]="node.cardMergeLimit"
          [attr.data-testid]="'card-merge-limit-select'"
          >
          @for (item of cardMergeLimits; track item) {
            <mat-option
              [value]="item"
              [attr.data-testid]="'card-merge-limit-option-' + item"
              >
              {{ item }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
